import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CounsellingDashboardRoutingModule } from './counselling-dashboard-routing.module';
import { CounsellingDashboardComponent } from './counselling-dashboard/counselling-dashboard.component';
import { CounsellingDashboardLandingComponent } from './counselling-dashboard-landing/counselling-dashboard-landing.component';
import { CounsellingDashboardLinksComponent } from './counselling-dashboard-links/counselling-dashboard-links.component';
import { CounsellingDashboardViewComponent } from './counselling-dashboard-view/counselling-dashboard-view.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { BrowserModule } from '@angular/platform-browser';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {IvyCarouselModule} from 'angular-responsive-carousel';

@NgModule({
  declarations: [
    CounsellingDashboardComponent,
    CounsellingDashboardLandingComponent,
    CounsellingDashboardLinksComponent,
    CounsellingDashboardViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    // BrowserModule,
    ReactiveFormsModule,
    CounsellingDashboardRoutingModule,
    // BrowserAnimationsModule,
    MatDatepickerModule,
    AcademicFormModule,
    IvyCarouselModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),

  ]
})
export class CounsellingDashboardModule { }
